import { core, payloadToJSON, toEnumString } from '@tock/coretypes';
import protos from 'utils/protos';

import AppConstants from 'constants/AppConstants';

export interface State {
  availableTagsForBusiness: core.MetaTag[];
  availableTagsForTicketType: core.MetaTag[];
}

const initialState: State = {
  availableTagsForBusiness: [],
  availableTagsForTicketType: [],
};

const { MetaTag } = protos;

const taggableClassNames = {
  TICKET_TYPE: toEnumString(MetaTag.TaggableClassName, MetaTag.TaggableClassName.TICKET_TYPE),
  BUSINESS: toEnumString(MetaTag.TaggableClassName, MetaTag.TaggableClassName.BUSINESS),
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload, context } = action;
  switch (type) {
    case AppConstants.METATAG_FETCH_DONE: {
      const sortedTagData = payloadToJSON<core.MetaTag[]>(payload).sort(
        (mt1: core.MetaTag, mt2: core.MetaTag) => (mt1.name < mt2.name ? -1 : 1)
      );

      if (context === taggableClassNames.TICKET_TYPE) {
        return {
          ...state,
          availableTagsForTicketType: sortedTagData,
        };
      } else if (context === taggableClassNames.BUSINESS) {
        return {
          ...state,
          availableTagsForBusiness: sortedTagData,
        };
      }

      return { ...state };
    }
    default:
      return state;
  }
}
